import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { rpMediaQueries } from '../../core/theme'
import { ReactComponent as Ante } from './img/ante.svg'
import { ReactComponent as Bet } from './img/bet.svg'
import { ReactComponent as Bonus } from './img/bonus.svg'
import img from './img/box-background.png'

export const BgMixin = css`
  background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.08) 0%,
      rgba(255, 255, 255, 0.02) 50%,
      rgba(0, 0, 0, 0.15) 100%
    ),
    linear-gradient(0deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.15) 100%),
    url(${img}) -235.425px -67.504px / 720.101% 339.706% no-repeat,
    rgba(0, 0, 0, 0.3);
  background-size: contain;

  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37),
    0 0 1px 0 rgba(255, 255, 255, 0.3) inset,
    0 20px 40px 0 rgba(255, 255, 255, 0.05) inset,
    0 -1px 2px 0 rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(16px) saturate(180%) brightness(1.05);
  -webkit-backdrop-filter: blur(16px) saturate(180%) brightness(1.05);
`

export const SeatBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
`

export const ContainerWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`

export const Container = styled.div`
  ${BgMixin};
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.15);

  padding: 5px;
  position: relative;
  width: 100%;

  ${rpMediaQueries.tablet} {
    padding: 13px 10px;
  }
`

export const Inside = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

export const BetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  ${rpMediaQueries.tablet} {
    gap: 12px;
  }
`

export const Number = styled.div`
  opacity: 0.12;
  border: 1px solid white;
  border-radius: 3px;
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -2px;
  left: -2px;
  padding: 1px 3px;
  transform: scale(0.7);
  transform-origin: top left;

  ${rpMediaQueries.tablet} {
    padding: 2px 6px;

    top: -8px;
    left: -5px;
  }
`

export type SelectedProps = { selected: boolean }

export const StyledBonus = styled(Bonus)<SelectedProps>`
  opacity: ${(p) => (p.selected ? 1 : 0.18)};
  width: 29px;
  height: auto;

  ${rpMediaQueries.tablet} {
    width: 55px;
  }
`

export const StyledAnte = styled(Ante)<SelectedProps>`
  opacity: ${(p) => (p.selected ? 1 : 0.18)};
  width: 58px;
  height: auto;

  ${rpMediaQueries.tablet} {
    width: 110px;
  }
`

export const StyledBet = styled(Bet)<SelectedProps>`
  opacity: ${(p) => (p.selected ? 1 : 0.18)};
  width: 70px;
  height: auto;

  ${rpMediaQueries.tablet} {
    width: 130px;
  }
`

export const BoxBetActions = styled.div<{
  disabled?: boolean
}>`
  padding: 4px 0;
  display: flex;
  gap: 3px;
  align-items: center;
  justify-content: space-evenly;

  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}

  ${rpMediaQueries.tablet} {
    padding: 16px 0 8px;
    gap: 6px;
  }
`

// BAB = bonus, bet, ante
export const ContainerBAB = styled.div<SelectedProps>`
  position: relative;
  display: flex;
  cursor: ${(p) => (p.selected ? 'pointer' : 'default')};
  transition: filter 0.2s ease-in-out;

  ${(p) =>
    p.selected &&
    css`
      &:hover {
        filter: brightness(1.2) drop-shadow(0 0 8px rgba(255, 196, 69, 0.6));
      }
    `}
`

export { Ante, Bet, Bonus }
